<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>e-Sign</h2>
    </div>
  </div>
  <div v-if="!signingUrl" class="wrapper wrapper-content">

    <div class="ibox-body">
      <div class="ibox-title style_2">
        <h5 class="my-0">Documents</h5>
      </div>
      <div class="ibox-content">
        <div class="ibox-content mb-1 px-3 py-2">
          <div class="form-group mb-1">
            <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">

              <!-- Document Title Search -->
              <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                <label class="mb-0"> {{ $t("navigations.title") }}</label>
                <input v-model="searchField.documentTitle" type="text" class="form-control my-md-2 my-lg-0" />
              </div>
        <div class="form-group mb-lg-0 w-100 px-1">
            <label class="mb-0"> Assigned Date</label>
            <div class="input-group date">
              <input
                v-model="searchField.createdAt"
                type="date"
                class="form-control my-md-2 my-lg-0"
              />
            </div>
          </div>
              <!-- Document Status Search -->
              <div class="form-group mb-lg-0 w-100 px-1">
                <label class="mb-0">Sign Status</label>
                <select class="form-select my-md-2 my-lg-0" v-model="searchField.status">
                  <option value="">All</option>
                  <option value="created">Awaiting</option>
                  <option value="sent">Pending</option>
                  <option value="completed">Signed</option>
                  <!-- <option value="declined">Declined</option>
                  <option value="voided">Voided</option> -->
                </select>
              </div>

              <!-- Search Button -->
              <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end"
                @click.prevent="searchDocuments">
                {{ $t("navigations.search") }}
              </span>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <div class="text-center" v-if="showLoading === true">
            <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>
          <template v-else>
            <div class="text-center" v-if="signerslist.length == 0">
              {{ $t('navigations.no data available') }}
            </div>

            <table v-else class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th  @click="SortSelected('documentTitle',0)"
                    :class="{
                      sortAsc: SortProperty === 'documentTitle' && SortOrder,
                      sortDesc: SortProperty === 'documentTitle' && !SortOrder,
                  }">
                  <div class="d-flex flex-row justify-content-between">
                    Document Title
                     <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                   
                  </th>
                      <th  @click="SortSelected('documentName',1)"
                    :class="{
                      sortAsc: SortProperty === 'documentName' && SortOrder,
                      sortDesc: SortProperty === 'documentName' && !SortOrder,
                  }">
                  <div class="d-flex flex-row justify-content-between">
                    Document Name
                     <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                   
                  </th>
                   <th  @click="SortSelected('artifactName',2)"
                    :class="{
                      sortAsc: SortProperty === 'artifactName' && SortOrder,
                      sortDesc: SortProperty === 'artifactName' && !SortOrder,
                    }">
                      <div class="d-flex flex-row justify-content-between">
                          Artifact Name
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                      </div>
                  </th>
                  <th @click="SortSelected('createdAt')"
                  :class="{
                    sortAsc: SortProperty === 'createdAt' && SortOrder,
                    sortDesc: SortProperty === 'createdAt' && !SortOrder,
                  }">
                    <div class="d-flex flex-row justify-content-between">
                      Assigned Date
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    Created By
                  </th>
                  <!-- <th>
                    Sign Order
                  </th> -->
                  <th>
                    Signed Date
                  </th>
                  <!-- <th>Document Status</th> -->
                  <th>Sign Status</th>
                  <th> Sign Document
                  </th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="userlist in signerslist" :key="userlist.id">
                  <tr v-for="Signer in userlist.recipients" :key="Signer.recipientEmail">
                    <td class="wrap-text">{{ userlist.documentTitle }}</td>
                    <td class="wrap-text">{{ userlist.documentName }}</td>
                    <td class="wrap-text">{{ userlist.artifactName }}</td>
                    <td>{{ userlist.createdAt.slice(0, 10) }}</td>
                    <td class="text-center">{{ userlist.createdByUserName }}</td>

                    <!-- <td>{{ Signer.recipientSignOrder }}</td> -->
                    <td>{{ Signer.recipientSignedDate ? Signer.recipientSignedDate.slice(0, 10) : "" }}</td>
                    <!-- <td class="wrap-text">{{ datacorrected[userlist.status] ?
                      datacorrected[userlist.status] : userlist.status }}</td> -->
                    <td class="wrap-text">{{
                      datacorrected[Signer.recipientStatus] ? datacorrected[Signer.recipientStatus] :
                        Signer.recipientStatus
                      }}</td>
                    <td class="text-center">
                      <a
                      v-if="Signer.recipientStatus !== 'completed' && Signer.recipientStatus !== 'created'"
                      @click.prevent="getiframeapi(userlist.envelopeId, Signer.recipientEmail, Signer.recipientSignOrder)">
                      <img src="../../assets/img/icons/digital-signature.png" width="15" class="" />
                      </a>
                    </td>
                    <td class="tdtext">
                      <a href="#" v-if="Signer.recipientStatus === 'completed'"
                      @click.prevent="getiframeapi(userlist.envelopeId, Signer.recipientEmail, Signer.recipientSignOrder)" class="editicon"><i class="fa fa-eye" @click="viewDocumentDetails(item.id, 'active alerts')"></i></a>
                   
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="signerslist.length != 0">
              <VPagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#ededed"
                @update:modelValue="loadPage" />
            </div>
          </template>
        </div>
        <!-- <div class="col-lg-12 d-flex justify-content-lg-end px-0" v-if="signerslist.length != 0">
          <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#f4f9ff"
            @update:modelValue="loadsignerslist" />
        </div> -->
      </div>
    </div>
  </div>
  <div v-if="signingUrl" class="wrapper wrapper-content animated fadeInRight">
  <!-- Preparing / fetching the signing URL -->
  <div v-if="isSigningUrlFetching" class="iframe-loader-container">
    <div class="iframe-loader">
      <img src="../../assets/img/loading.gif" width="24" alt="Loading..." />
      <div class="mt-2 small-text">Preparing signing session…</div>
    </div>
  </div>


  <!-- Iframe + loader while the document loads -->
  <div v-else class="iframe-container">
    <div v-if="isIframeLoading" class="iframe-loader-overlay">
      <div class="iframe-loader">
        <img src="../../assets/img/loading.gif" width="24" alt="Loading..." />
        <div class="mt-2 small-text">Loading document…</div>
      </div>
    </div>
<span class="tooltip-wrapper pointer" style="float:right">
    <i 
      class="fa fa-times cursor-pointer" 
      @click="signingUrl = null">
    </i>
    <span class="custom-tooltip closetooltipposition">Close</span>
  </span>
    <iframe
      v-if="iframeurl"
      ref="dsFrame"
      :src="iframeurl"
      width="100%"
      height="650"
      frameborder="0"
      @load="onIframeLoad"
    />
  </div>
</div>

</template>

<script src="./signerslist.js"></script>
<style scoped>
.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.badge-warning {
  background-color: #f8ac59;
  color: #ffffff;
}

.badge-danger {
  background-color: #ed5565;
  color: #ffffff;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 200px;
}

.btn-green-new {
  color: #fff;
  background-color: #1ab394;
  /* border-color: #1ab394; */
  border: none;
}

.btn-danger-new {
  color: #fff;
  background-color: #ed5565;
  border: none;
}

.text-green {
  color: #1ab394 !important;
}

.rotate {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}

.height-scroll {
  height: 250px;
  overflow-y: auto;
}

.small-text {
  font-size: 80%;
  font-weight: 400;
  color: #6b6b6b;
}
</style>
